jQuery(document).ready(function ($) {

    $('.steps__item').on('click', '.main-title', function () {
        $(this)
            .toggleClass('active')
            .next()
            .stop().slideToggle()
    });

    $('.questions__item').on('click', '.main-title', function () {
        $(this)
            .toggleClass('active')
            .next()
            .stop().slideToggle()
    });
});
